import React, { ReactElement } from 'react'
import classNames from 'classnames'

type ButtonProps = {
  className?: string
  icon?: string
  small?: boolean
} & React.ButtonHTMLAttributes<HTMLButtonElement>

const Button: React.FC<ButtonProps> = ({
  className,
  icon,
  children,
  small,
  ...rest
}) => (
  <button
    className={classNames('button', className, { 'is-small': small })}
    type="button"
    {...rest}
  >
    {icon && (
      <span className="icon">
        <i className={icon} />
      </span>
    )}

    {children && <span>{children}</span>}
  </button>
)

export default Button

//

type ButtonGroupProps = {
  children: ReactElement[]
}

export const ButtonGroup: React.FC<ButtonGroupProps> = ({ children }) => (
  <div className="field has-addons">
    {children.map((button, i) => (
      <p className="control" key={i}>
        {button}
      </p>
    ))}
  </div>
)
